export default {
  pdfPageNavigator: {
    pagina: 'Página',
    de: 'de'
  }
};
